"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ENDPOINT_EVENT = exports.FILTER_TYPES = void 0;
var FILTER_TYPES;
(function (FILTER_TYPES) {
    FILTER_TYPES["ALL"] = "any-day";
    FILTER_TYPES["TODAY"] = "today";
    FILTER_TYPES["TOMORROW"] = "tomorrow";
    FILTER_TYPES["THIS_WEEK"] = "this-week";
})(FILTER_TYPES = exports.FILTER_TYPES || (exports.FILTER_TYPES = {}));
exports.API_ENDPOINT_EVENT = 'experiences';
//# sourceMappingURL=HankEvent.js.map